import React, { useEffect } from "react";
import { useTranslation } from 'react-i18next';
import { login } from "../../services/actions/user";
import {Controller, useForm} from "react-hook-form";
import styles from "./login.module.scss";
import { useAppDispatch } from "../../hooks/useAppDispatch";
import { useAppSelector } from "../../hooks/useAppSelector";
import { removeLoginError } from "../../services/reducers/user";
import Input from "../../components/ui-kit/Input/input";
import Button from "../../components/ui-kit/button/button";

interface FormData {
  login: string;
  password: string;
}

export function LoginPage() {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();

  const {handleSubmit, control, formState: { errors }} = useForm<FormData>();

  const onSubmit = (data: FormData) => {
    dispatch(login({ email: data.login, password: data.password }));
  };
  
  useEffect(() => {
    return () => {
      dispatch(removeLoginError())
    }
  }, [])

  const loginError = useAppSelector((state) => state.user.loginError);

  return (
      <div className={styles.loginPage}>
        <h1 className={styles.loginPageTitle}>
          {t('login.title')}
        </h1>
        <form onSubmit={handleSubmit(onSubmit)} className={styles.loginForm}>
          <div className={styles.formGroups}>
            <label className={styles.formGroupsItem}>
              <Controller
                  name='login'
                  control={control}
                  rules={{
                    required: t('login.loginRequired'),
                  }}
                  render={({field}) => (
                      <Input
                          value={field.value || ""}
                          onChange={field.onChange}
                          placeholder={t('login.loginPlaceholder')}
                          label={t('login.loginLabel')}
                          classes={{
                              label: styles.titleInput
                          }}
                          hasError={!!errors.login}
                      />
                  )}
              />
              <span
                className={`${styles.inputHint} ${(errors.login || loginError) && styles.errorMessage}`}
              >
                {errors.login
                  ? errors.login.message
                  : loginError
                    ? t('login.incorrectCredentials')
                    : t('login.contactAdminHint')}
              </span>
            </label>
            <label className={styles.formGroupsItem}>
              <Controller
                  name='password'
                  control={control}
                  rules={{
                    required: t('login.passwordRequired')
                  }}
                  render={({field}) => (
                      <Input
                          value={field.value || ""}
                          onChange={field.onChange}
                          placeholder={t('login.passwordPlaceholder')}
                          label={t('login.passwordLabel')}
                          type='password'
                          classes={{
                              label: styles.titleInput
                          }}
                          hasError={!!errors.password}
                      />
                  )}
              />
              <span
                className={`${styles.inputHint} ${(errors.password || loginError) && styles.errorMessage}`}
              >
                {errors.password
                  ? errors.password.message
                  : loginError
                    ? t('login.incorrectCredentials')
                    : t('login.forgotPasswordHint')}
              </span>
            </label>
          </div>
          <Button type="primary" className={styles.loginButton}>
            {t('login.signInButton')}
          </Button>
        </form>
      </div>
  );
}
